module.exports = __webpack_public_path__ + "img/air-icon.05412e10.png";